module.exports = __webpack_public_path__ + "media/images/app/collections/collection-rings-661f074485e0315717875b2196fae588.webp";